import {useQuery} from "@tanstack/react-query";
import LibraryService from "../../../../../../services/web/library-service.js";
import ModalAttaches from "../../../../../../components/modal/modal-attaches.jsx";
import {useLayoutEffect, useRef, useState} from "react";
import {imageExtensions} from "../../../utils/library-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

export default function LibraryTypeDocument({ item }) {
    const documentId = item?.id;

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [descriptionClamp, setDescriptionClamp] = useState(1);
    const descriptionBoxRef = useRef(null);

    const { data } = useQuery({
        queryKey: ["library-document-preview", documentId],
        queryFn: () => LibraryService.getDocById(documentId),
        enabled: !!documentId
    });

    useLayoutEffect(() => {
        if (!descriptionBoxRef.current) return;

        const calculateClamp = () => {
            const box = descriptionBoxRef.current;
            const style = window.getComputedStyle(box);
            const lineHeight = parseFloat(style.lineHeight);
            const paddingTop = parseFloat(style.paddingTop);
            const paddingBottom = parseFloat(style.paddingBottom);
            const availableHeight = box.clientHeight  - paddingTop - paddingBottom;
            const lines = Math.floor(availableHeight / lineHeight);

            setDescriptionClamp(Math.max(lines, 1));
        }

        calculateClamp();

        const resizeObserver = new ResizeObserver(calculateClamp);
        resizeObserver.observe(descriptionBoxRef.current);

        window.addEventListener("resize", calculateClamp);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", calculateClamp);
        }
    }, [data?.description]);

    if (!data) return null;
    const openAttach = (attach) => {
        const extension = (attach.type ?? attach.name?.split(".").pop())?.toLowerCase();

        setSelectedFile({
            ...attach,
            attachId: attach.attachId ?? attach.id,
            extension,
            url: attach.url ?? `${API_KEEPER}/ged/attach/${attach.attachId ?? attach.id}`,
        });

        setModalOpen(true);
    };

    return (
        <>
            <div className="space-y-4 mt-2">
                <section className="space-y-2">
                    <h2 className="text-sm! font-bold">Conteúdo</h2>
                    <div
                        ref={descriptionBoxRef}
                        className="min-h-[calc(100vh-512px)]! overflow-hidden rounded-lg border border-zinc-200 p-3 text-xs text-zinc-700"
                    >
                        {data.description ? (
                            <div
                                className="
                                    [&_ul]:list-disc [&_ul]:pl-5
                                    [&_ol]:list-decimal [&_ol]:pl-5
                                "
                                style={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: descriptionClamp,
                                    overflow: "hidden",
                                }}
                                dangerouslySetInnerHTML={{ __html: data.description }}
                            />
                        ) : (
                            <p className="text-zinc-400">
                                Este Sentry Doc não possui conteúdo.
                            </p>
                        )}
                    </div>
                </section>
                <section className="space-y-2">
                    <h2 className="text-sm! font-bold">Anexos</h2>

                    <div className="min-h-30! rounded-lg border border-zinc-200 p-3">
                        {data.attaches?.length ? (
                            <div className="flex flex-wrap gap-2">
                                {data.attaches.map((file, index) => {
                                    const fileExtension = file.name?.split(".").pop()?.toLowerCase();

                                    const isImage = imageExtensions.includes(fileExtension);

                                    let url = file.url ?? `${API_KEEPER}/ged/attach/${file.attachId ?? file.id}`;

                                    if (!isImage) {
                                        url = `${API_URL}/public/assets/img/file-types/${fileExtension}.png`;
                                    }

                                    return (
                                        <button
                                            key={file.attachId ?? file.id ?? index}
                                            type="button"
                                            onClick={() => openAttach(file)}
                                            title={file.name}
                                            className="flex h-24 w-20 items-center justify-center overflow-hidden cursor-pointer bg-contain bg-center bg-no-repeat"
                                            style={{ backgroundImage: `url(${url})` }}
                                        />
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="flex min-h-24 items-center justify-center">
                                <p className="text-xs text-zinc-400">
                                    Este Sentry Doc não possui anexos.
                                </p>
                            </div>
                        )}
                    </div>
                </section>
            </div>
            <ModalAttaches
                open={modalOpen}
                setOpen={setModalOpen}
                file={selectedFile}
            />
        </>
    )
}